import { render, staticRenderFns } from "./KanbanCardModal.vue?vue&type=template&id=5c62bb53&scoped=true&"
import script from "./KanbanCardModal.vue?vue&type=script&lang=js&"
export * from "./KanbanCardModal.vue?vue&type=script&lang=js&"
import style0 from "./KanbanCardModal.vue?vue&type=style&index=0&id=5c62bb53&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c62bb53",
  null
  
)

export default component.exports